if (!customElements.get('style-video-modal')) {
  customElements.define(
    'style-video-modal',
    class StyleVideoModal extends ModalDialog {
      constructor() {
        super();
        this.soundToggle = this.querySelector('[data-sound-toggle]');
        if (this.soundToggle) {
          this.soundToggle.addEventListener('click', this.toggleSound.bind(this));
        }
      }

      show(opener) {
        super.show(opener);
        this.playVideo();
      }

      // Loads (first time) and plays the video as part of the same click that
      // opened the modal, instead of requiring a second click on a poster.
      // Starts muted, since browsers reliably allow muted autoplay but often
      // silently block or ignore unmuted autoplay (especially on mobile) —
      // the sound toggle button lets the customer turn sound on with an
      // explicit tap, which browsers always allow.
      playVideo() {
        const deferredMedia = this.querySelector('deferred-media');
        if (!deferredMedia) return;

        let video = deferredMedia.querySelector('video');

        if (!video && !deferredMedia.getAttribute('loaded')) {
          const template = deferredMedia.querySelector('template');
          if (!template) return;
          const content = template.content.firstElementChild.cloneNode(true);
          deferredMedia.setAttribute('loaded', true);
          if (content.nodeName === 'VIDEO') {
            content.muted = true;
            content.playsInline = true;
          }
          video = deferredMedia.appendChild(content);
        }

        if (!video || video.nodeName !== 'VIDEO') return;

        this.videoElement = video;

        if (this.soundToggle) {
          this.soundToggle.hidden = false;
          this.soundToggle.setAttribute('data-muted', video.muted ? 'true' : 'false');
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            // Autoplay blocked entirely (rare, with muted) — the poster stays
            // visible and native controls still let the customer press play.
          });
        }
      }

      toggleSound() {
        if (!this.videoElement) return;
        this.videoElement.muted = !this.videoElement.muted;
        this.soundToggle.setAttribute('data-muted', this.videoElement.muted ? 'true' : 'false');
      }
    }
  );
}
